// extracted by mini-css-extract-plugin
export default {"root":"SettingsToggle_root__0+VSd","active":"SettingsToggle_active__SC1hV"};